import type { ParamMap } from '@angular/router';

export type CrmStatusOption = { _id: string; code: string; name: string };

const LEAD_ROUTE_FILTER_KEYS = [
  'statusCode',
  'createdToday',
  'showEnrolled',
  'showDisqualified',
  'includeEnrolled',
  'pendingTasksAssignedToMe',
] as const;

const APPLICANT_ROUTE_FILTER_KEYS = [
  'statusCode',
  'statusCodes',
  'createdToday',
  'pendingTasksAssignedToMe',
  'showDisqualified',
] as const;

export function hasLeadRouteFilters(params: ParamMap): boolean {
  return LEAD_ROUTE_FILTER_KEYS.some((key) => params.has(key));
}

export function hasApplicantRouteFilters(params: ParamMap): boolean {
  return APPLICANT_ROUTE_FILTER_KEYS.some((key) => params.has(key));
}

export function resolveStatusIdFromCode(
  statusCode: string | null,
  statuses: CrmStatusOption[],
): string {
  if (!statusCode) {
    return '';
  }
  return statuses.find((status) => status.code === statusCode)?._id ?? '';
}

export type LeadRouteFilterValues = {
  statusId: string;
  createdFrom: string;
  createdTo: string;
  showEnrolled: boolean;
  showDisqualified: boolean;
  includeEnrolled: boolean;
  createdToday: boolean;
  pendingTasksAssignedToMe: boolean;
};

export function readLeadRouteFilters(
  params: ParamMap,
  statuses: CrmStatusOption[],
): LeadRouteFilterValues {
  return {
    statusId: resolveStatusIdFromCode(params.get('statusCode'), statuses),
    createdFrom: '',
    createdTo: '',
    showEnrolled: params.get('showEnrolled') === 'true',
    showDisqualified: params.get('showDisqualified') === 'true',
    includeEnrolled: params.get('includeEnrolled') === 'true',
    createdToday: params.get('createdToday') === 'true',
    pendingTasksAssignedToMe: params.get('pendingTasksAssignedToMe') === 'true',
  };
}

export type ApplicantRouteFilterValues = {
  statusId: string;
  statusCodes: string;
  createdFrom: string;
  createdTo: string;
  createdToday: boolean;
  pendingTasksAssignedToMe: boolean;
  showDisqualified: boolean;
};

export function readApplicantRouteFilters(
  params: ParamMap,
  statuses: CrmStatusOption[],
): ApplicantRouteFilterValues {
  const statusCodes = params.get('statusCodes')?.trim() ?? '';
  return {
    statusId: statusCodes ? '' : resolveStatusIdFromCode(params.get('statusCode'), statuses),
    statusCodes,
    createdFrom: '',
    createdTo: '',
    createdToday: params.get('createdToday') === 'true',
    pendingTasksAssignedToMe: params.get('pendingTasksAssignedToMe') === 'true',
    showDisqualified: params.get('showDisqualified') === 'true',
  };
}
